/**
 * Derlemede gömülen genel yapılandırma (bkz. vite.web.config.ts > publicConfig).
 * Yalnızca herkese açık değerler; sır yok.
 */
declare const __TALKNOTE_WEB_CONFIG__: {
  supabaseUrl: string;
  supabaseAnonKey: string;
  apiUrl: string;
  deepgramModel: string;
  version: string;
};

export const WEB_CONFIG = __TALKNOTE_WEB_CONFIG__;

/** Uygulamanın kendi adresi (OAuth dönüşleri buraya). */
export function appOrigin(): string {
  return window.location.origin;
}
